import { VEHICLE_API_BASE } from "@/config/apiConfig";
import { languageUtils } from "@/utils/languageUtils";

export interface VehicleMake {
  maId: string;
  maNa: string;
  maCo: string;
}

export interface VehicleModel {
  moId: string;
  moNa: string;
  moCo: string;
}

interface VehicleListResponse<T> {
  data: T[];
}

async function vehicleFetch<T>(path: string): Promise<T> {
  const lang = languageUtils.getCurrentLanguage();
  const res = await fetch(`${VEHICLE_API_BASE}${path}`, {
    method: "GET",
    headers: {
      accept: "text/plain",
      lang,
    },
  });

  if (!res.ok) {
    throw new Error(`Vehicle API request failed: ${res.status}`);
  }

  return res.json() as Promise<T>;
}

export async function fetchVehicleMakes(): Promise<VehicleMake[]> {
  const json = await vehicleFetch<VehicleListResponse<VehicleMake>>("/makes");
  return json.data ?? [];
}

export async function fetchVehicleModels(makeId: string): Promise<VehicleModel[]> {
  const json = await vehicleFetch<VehicleListResponse<VehicleModel>>(
    `/models?makeId=${encodeURIComponent(makeId)}`
  );
  return json.data ?? [];
}
